import type { BadgeVariant } from '@/types/common.types';
import type { VibrantOrderStatusKey } from '@/services/labs.service';

/**
 * Badge tone for a Vibrant order's derived status, shared by the patient's
 * order list and the order detail so the two always agree.
 */
export function vibrantStatusVariant(key: VibrantOrderStatusKey | null | undefined): BadgeVariant {
  switch (key) {
    case 'received':
      return 'success';
    case 'awaiting':
      return 'info';
    case 'unconfirmed':
      return 'warning';
    case 'failed':
      return 'error';
    default:
      return 'neutral';
  }
}
